
interface menu{
    isTitle:boolean
    hasChildren:boolean
    title?:string
    name?:string
    route?:string
    tag?:string
    status?:boolean
    space?:string
    children?: menu[]
    tags:string[]
}

export const AdministrationMenu:menu[]=[
    {
        isTitle:true,
        title:"Paramètres",
        hasChildren:false,
        status:false,
        tags:['Utilisateurs','Permissions','Rôles','Profils','Sauvegardes']

    },
    {
        isTitle:false,
        name:"Gestion des utilisateurs",
        hasChildren:true,
        status:false,
        tags:['Utilisateurs','Permissions','Rôles','Profils'],
        children:[
            {
                isTitle:false,
                name:"Utilisateurs",
                route:'/users',
                hasChildren:false,
                status:false,
                tags:['Utilisateurs']
            
            },
            {
                isTitle:false,
                name:"Rôles",
                route:'/roles',
                hasChildren:false,
                status:false,
                tags:['Rôles']
            
            },
            {
                isTitle:false,
                name:"Permissions",
                route:'/permissions',
                hasChildren:false,
                status:false,
                tags:['Permissions']
            
            },
            {
                isTitle:false,
                name:"Rôles et Permissions",
                route:'/profiles',
                hasChildren:false,
                status:false,
                tags:['Profils']
            
            },
        ]
    },
    {
        isTitle:false,
        name:"Sauvegarde",
        route:'/backups',
        hasChildren:false,
        status:false,
        tags:['Sauvegardes']
    
    },
    {
        isTitle:false,
        name:"Pays",
        route:'/configurations/countries',
        hasChildren:false,
        status:false,
        tags:['Pays']
    
    }
]

export const ConfigurationMenu:menu[]=[
    {
        isTitle:true,
        title:"Accueil",
        hasChildren:false,
        status:false,
        tags:["Tableau de bord","Propriétaires","Locataires","Dépenses","Mensualités","Maisons","Locations","Transactions","Cvthèques","Frais Transactions"]

    },
    {
        isTitle:false,
        name:"Tableau de bord",
        route:'/dashboard',
        hasChildren:false,
        status:false,
        tags:["Tableau de bord"]
    },
    {
        isTitle:false,
        name:"Gestion des finances",
        route:'/financials',
        hasChildren:false,
        status:false,
        tags:["Finances"]
    },
    {
        isTitle:false,
        name:"Gestion des Apps",
        route:'/applications',
        hasChildren:false,
        status:false,
        tags:["Applications"]
    },
    {
        isTitle:false,
        name:"Articles",
        route:'/items',
        hasChildren:false,
        status:false,
        tags:["Articles"]
    },
    {
        isTitle:false,
        name:"Boostages",
        route:'/boosts',
        hasChildren:false,
        status:false,
        tags:["Boostages"]
    },
    {
        isTitle:false,
        name:"Gestion des tarifications",
        route:'/tarifications',
        hasChildren:false,
        status:false,
        tags:["Tarifications"]
    },
    {
        isTitle:false,
        name:"Gestion des livreurs",
        route:'/delivers',
        hasChildren:false,
        status:false,
        tags:["Livreurs"]
    },
    {
        isTitle:false,
        name:"Catégorie",
        route:'/categories',
        hasChildren:false,
        status:false,
        tags:["Categories"]
    },
    {
        isTitle:false,
        name:"Transactions",
        route:'/transactions',
        hasChildren:false,
        status:false,
        tags:["Categories"]
    },
     {
        isTitle:false,
        name:"Frais de transactions",
        route:'/transaction-fees',
        hasChildren:false,
        status:false,
        tags:["Categories"]
    },
     {
        isTitle:false,
        name:"Gestion des Commandes",
        route:'/orders',
        hasChildren:false,
        status:false,
        tags:["Livraisons"]
    },
     {
        isTitle:false,
        name:"Gestion des livraisons",
        route:'/deliveries',
        hasChildren:false,
        status:false,
        tags:["Livraisons"]
    },
    {
        isTitle:false,
        name:"Boutiques",
        route:'/stores',
        hasChildren:false,
        status:false,
        tags:["Boutiques"]
    },
    {
        isTitle:false,
        name:"Abonnements",
        route:'/subscriptions',
        hasChildren:false,
        status:false,
        tags:["Abonnements"]
    },
    {
        isTitle:false,
        name:"Influenceurs",
        route:'/influencers',
        hasChildren:false,
        status:false,
        tags:["Influenceurs"]
    },
     {
        isTitle:false,
        name:"Vidéos",
        route:'/videos',
        hasChildren:false,
        status:false,
        tags:["Vidéos"]
    },
    {
        isTitle:false,
        name:"Parainages",
        route:'/sponsorships',
        hasChildren:false,
        status:false,
        tags:["Parainages"]
    },
    {
        isTitle:false,
        name:"Cvthèque",
        route:'/cvs',
        hasChildren:false,
        status:false,
        tags:["Categories"]
    },
    {
        isTitle:false,
        name:"Prestataires",
        route:'/providers',
        hasChildren:false,
        status:false,
        tags:["Categories"]
    },
    {
        isTitle:false,
        name:"Demande de service",
        route:'/requests',
        hasChildren:false,
        status:false,
        tags:["Categories"]
    },
    {
        isTitle:false,
        name:"Services (Mise en relation)",
        route:'/services',
        hasChildren:false,
        status:false,
        tags:["Categories"]
    },
    {
        isTitle:false,
        name:"Formation en ligne",
        route:'/courses',
        hasChildren:false,
        status:false,
        tags:["Categories"]
    },
    {
        isTitle:false,
        name:"Réservations de véhicules",
        route:'/car-reservations',
        hasChildren:false,
        status:false,
        tags:["Réservations véhicules"]
    },
    {
        isTitle:false,
        name:"Notifications",
        route:'/notifications',
        hasChildren:false,
        status:false,
        tags:["Notifications"]
    },
    {
        isTitle:false,
        name:"Pressing",
        route:'/pressing',
        hasChildren:false,
        status:false,
        tags:["Pressing"]
    }
]